import { useMutation } from '@tanstack/react-query';
import { useDialogs, useNotifications } from '@toolpad/core';
import { useNavigate } from 'react-router';
import {
    Card,
    CardContent,
    CardHeader,
    Stack,
    Typography,
} from '@mui/material';
import Button from '@mui/material/Button';

import Api from '@barboxx/api';
import { ProductType } from '@barboxx/models';

interface Props {
    productType: ProductType.DetailsResponse;
}

export const ProductTypeDeleteCard = ({ productType }: Props) => {
    const notifications = useNotifications();
    const navigate = useNavigate();
    const dialog = useDialogs();

    const mutateDeleteAlcohol = useMutation({
        mutationKey: ['deleteProductType', productType.id],
        mutationFn: () => Api.Products.Types.deleteProductType(productType),
    });

    const onDelete = async () => {
        const deleteConfirmed = await dialog.confirm(
            'Are you sure you want to Delete this product subtype!',
            {
                severity: 'error',
                okText: 'Delete',
                title: 'Delete Alcohol subtype',
            }
        );

        if (!deleteConfirmed) {
            return;
        }

        mutateDeleteAlcohol
            .mutateAsync()
            .then(({ data }) => {
                notifications.show('Deleted product type!', {
                    severity: 'success',
                });
                navigate('/products/types');
            })
            .catch(e => {
                notifications.show('Error Deleting product type!', {
                    severity: 'error',
                });
            });
    };

    return (
        <Card>
            <CardHeader title="Delete Alcohol Type" />
            <CardContent>
                <Stack gap={2} direction="row">
                    <Typography flex={1}>
                        Are you sure you want to Delete this product type?
                    </Typography>

                    <Button onClick={onDelete} color="error" variant="outlined">
                        Delete
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
};
